"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = void 0;

var _redux = require("redux");

var _user = require("./user");

var _organisations = require("./organisations");

var _products = require("./products");

var _settings = require("./settings");

var _teams = require("./teams");

var _authorisation = _interopRequireDefault(require("./authorisation"));

var _loginStatus = require("./loginStatus");

var _userDataRetrievalStatus = require("./userDataRetrievalStatus");

var _noAccessUserOrganisations = require("./noAccessUserOrganisations");

var _noAccessUserTeams = require("./noAccessUserTeams");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// $FlowFixMe
var reducer = (0, _redux.combineReducers)({
  user: _user.user,
  organisations: _organisations.organisations,
  teams: _teams.teams,
  authorisation: _authorisation["default"],
  products: _products.products,
  loginStatus: _loginStatus.loginStatus,
  userDataRetrievalStatus: _userDataRetrievalStatus.userDataRetrievalStatus,
  noAccessUserOrganisations: _noAccessUserOrganisations.noAccessUserOrganisations,
  noAccessUserTeams: _noAccessUserTeams.noAccessUserTeams,
  settings: _settings.settings
});
exports.reducer = reducer;